import { Button, Card, Divider, Drawer, Popconfirm, Table, Tag } from 'antd';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { notificacao } from '../master-page/redux/actions';
import FormRegistro from './FormRegistro';
import * as actions from './redux/actions';

export class Listar extends Component {
  static propTypes = {
    usuarioPerfil: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    drawerVisible: false,
    pendingSalve: false,
    formRegistroReadOly: false,
  };

  componentDidMount() {
    this.props.actions.listar({ order: 'Nome ASC' });
  }

  handleSubmit = form => {
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }
      this.setState({ pendingSalve: true });
      this.salvarRegistro({ ...this.props.usuarioPerfil.registro, ...values });
    });
  };

  salvarRegistro = registro => {
    this.props.actions.salvar(registro, action => {
      if (action === 'USUARIO_PERFIL_SALVAR_SUCCESS') {
        notificacao('success', 'Registro salvo');
        this.setState({ pendingSalve: false });
        this.setState({ drawerVisible: false });
        this.props.actions.deletarRegistro(action => {
          this.props.actions.listar({ order: 'Nome ASC' });
        });
      }
    });
  };
  deleteConfirm = registro => {
    console.log('Excluir ', registro);
    this.props.actions.deletar(registro, action => {
      if (action === 'USUARIO_PERFIL_DELETAR_SUCCESS') {
        notificacao('success', 'Registro excluído!');
        this.setState({ drawerVisible: false });
      } else {
        notificacao('error', 'Falha ao excluir registro');
      }
    });
  };

  showDrawer = registro => {
    if (registro) {
      this.props.actions.buscarPorId(registro.Codigo, action => {
        if (action === 'USUARIO_PERFIL_BUSCAR_POR_ID_SUCCESS') {
          this.setState({ drawerVisible: true, formRegistroReadOly: true });
        }
      });
    } else {
      this.setState({ drawerVisible: true, formRegistroReadOly: false });
    }
  };
  closeDrawer = () => {
    this.props.actions.deletarRegistro(action => {
      this.setState({ drawerVisible: false });
    });
  };
  render() {
    const { usuarioPerfil } = this.props;
    const colunas = [
      {
        title: 'Perfil',
        dataIndex: 'Nome',
        key: 'Nome',
      },
      {
        title: 'Ativo',
        dataIndex: 'Ativo',
        key: 'Ativo',
        render: text => {
          if (text === true) {
            return <Tag color="#108ee9">Ativo</Tag>;
          } else {
            return <Tag color="#ff0000">Inativo</Tag>;
          }
        },
      },
      {
        title: 'IDM GROUP',
        dataIndex: 'GP_IDM_GRP_AD',
        key: 'GP_IDM_GRP_AD',
      },
      {
        title: '',
        dataIndex: '',
        key: 'x',
        render: (text, record) => {
          return (
            <React.Fragment>
              <Button
                onClick={() => this.showDrawer(record)}
                type="default"
                size="small"
                icon="edit"
                loading={this.props.buscarPorIdPending}
              >
                Editar
              </Button>
              <Divider type="vertical" />
              <Popconfirm
                title="Confirma exclusão do registro?"
                okText="Sim"
                cancelText="Não"
                onConfirm={() => this.deleteConfirm(record)}
              >
                <Button type="danger" size="small" icon="delete">
                  Excluir
                </Button>
              </Popconfirm>
            </React.Fragment>
          );
        },
      },
    ];

    const FormDrawer = () => {
      return (
        <React.Fragment>
          <Drawer
            placement="right"
            visible={this.state.drawerVisible}
            title="Cadastro de Perfil de Usuário"
            onClose={() => this.closeDrawer()}
            width={500}
            closable={false}
          >
            <Card
              extra={
                <React.Fragment>
                  <Button
                    onClick={() => this.closeDrawer()}
                    type="primary"
                    icon="rollback"
                  >
                    Cancelar
                  </Button>
                  <Divider type="vertical" />
                  <Button 
                    onClick={() => this.formRef.props.onSubmit()} 
                    type="primary" 
                    icon="save"
                    loading={this.state.pendingSalve}
                  >
                    Salvar
                  </Button>
                </React.Fragment>
              }
            >
              <FormRegistro submitForm={this.handleSubmit} formRef={el => (this.formRef = el)} formReadOnly={this.state.formRegistroReadOly} />
            </Card>
          </Drawer>
        </React.Fragment>
      );
    };

    return (
      <div className="usuario-perfil-listar">
        <Card
          title="Lista de Perfil de Usuários"
          extra={
            <Button onClick={() => this.showDrawer()} type="primary" icon="form">
              Novo Perfil
            </Button>
          }
        >
          <Table
            dataSource={usuarioPerfil.registros}
            columns={colunas}
            size="small"
            loading={this.props.listarPending}
          />
        </Card>

        <FormDrawer />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    usuarioPerfil: state.usuarioPerfil,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Listar);



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/Listar.js